/**
 * Config: Navigation
 * -----------------------------------------------------------------------------
 * Global configuration for navigation.
 * - Add in alphabetical order.
 *
 */
export default {
  availableTags: ['new'],
  bannerCode: '[banner]',
}
